import React from 'react';
import { Input, Select } from '@avila-tek/ui/src';
import { TChartFilters } from '../../../models';
import { timeOptionsTranslate } from '../../../static/timeOptions';

interface ChartFiltersProps {
  chartFilters: TChartFilters;
  setChartFilters: React.Dispatch<React.SetStateAction<TChartFilters>>;
  loading: boolean;
  timeOptions: string[];
}

function ChartFilters({
  chartFilters,
  setChartFilters,
  loading,
  timeOptions,
}: ChartFiltersProps) {
  return (
    <div className="w-full flex flex-col lg:flex-row items-center justify-center h-full my-2 mb-5 lg:space-x-3">
      <div className="w-full">
        <Select
          label="Unidad de tiempo"
          className="w-full bg-white"
          onChange={(e) => {
            setChartFilters({
              ...chartFilters,
              timeScale: e.target.value,
            });
          }}
          value={chartFilters?.timeScale}
        >
          {timeOptions?.map((option) => (
            <option value={option} key={option}>
              {
                timeOptionsTranslate[
                  option as keyof typeof timeOptionsTranslate
                ]
              }
            </option>
          ))}
        </Select>
      </div>
      <div className="w-full">
        <Input
          value={chartFilters?.startDate}
          label="Fecha de inicio"
          type="date"
          onChange={(e) =>
            setChartFilters({
              ...chartFilters,
              startDate: e.target.value,
            })
          }
          className="bg-white"
          disabled={loading}
        />
      </div>
      <div className="w-full">
        <Input
          value={chartFilters?.endDate}
          label="Fecha de finalización"
          type="date"
          className="bg-white"
          placeholder="Ingrese un valor para la meta"
          onChange={(e) =>
            setChartFilters({
              ...chartFilters,
              endDate: e.target.value,
            })
          }
          disabled={loading}
        />
      </div>
    </div>
  );
}

export default ChartFilters;
